import {getOne, getAll, createOne, updateOne, deleteOne, getOneBy} from './Api.js';

const MODULE = 'lyrics';

export function getLyrics(id) {
	return getOne(MODULE, id);
}

export function getLyricsBySong(songId) {
	return getOneBy(MODULE, 'song', songId);
}

export function getAllLyrics() {
	return getAll(MODULE);
}

export function createLyrics(data) {
	return createOne(MODULE, data);
}

export function updateLyrics(data) {
	return updateOne(MODULE, data);
}

export function deleteLyrics(id) {
	return deleteOne(MODULE, id);
}
